<template>
  <div class="extend_list_box">
    <van-tabs
      v-model="params.goodsTypeId"
      sticky
      offset-top="11.733333vw"
      class="extend_list_tabs"
      @change="tabsChange"
    >
      <van-tab v-for="(i, index) in tabList" :title="i" :key="index">
        <van-list
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          :finished-text="list.length > 0 ? '加载完毕' : ''"
          @load="onLoad"
        >
          <div v-if="loading || list.length > 0">
            <van-cell
              class="extend_list_item"
              v-for="item in list"
              :key="item.id"
              @click="
                $router.push(
                  `/extend/extend-detail?goodsId=${item.goodsId}&nums=${item.goodsDealNums}&commission=${item.totalCommission}`
                )
              "
            >
              <div class="list_item_top">
                <img
                  class="list_item_cover"
                  :src="$global.imgUrl + item.logo.split(',')[0]"
                  alt=""
                />
                <h1 class="list_item_title">{{ item.goodsName }}</h1>
              </div>
              <div class="list_item_bottom">
                <div style="text-align: center">
                  <p class="list_item_text">成单数量</p>
                  <p class="list_item_num">{{ item.goodsDealNums }}</p>
                </div>
                <div style="text-align: center">
                  <p class="list_item_text">累计佣金</p>
                  <p class="list_item_num">
                    <span class="list_item_symbol">¥</span>
                    <span>{{ item.totalCommission }}</span>
                  </p>
                </div>
              </div>
            </van-cell>
          </div>
          <div class="extend_list_no" v-else>
            <img
              class="none_img"
              src="@/assets/img/mobileImg/tsZzNone.png"
              alt=""
            />
            <p class="no_text">您还没有推广商品</p>
            <van-button
              class="no_btn"
              round
              type="info"
              @click="$router.push('/extend/extend-market')"
              >去推广</van-button
            >
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabList: ["图书", "会议", "课程", "行业报告"],
      params: {
        pageNo: 1,
        pageSize: 10,
        goodsTypeId: 0,
        id: "",
      },
      list: [],
      loading: false,
      finished: false,
    };
  },
  created() {
    this.params.id = JSON.parse(sessionStorage.getItem("userInfo")).promoterId;
    this.getList();
  },
  methods: {
    onLoad() {
      this.params.pageNo++;
      this.getList();
    },
    tabsChange(name) {
      this.params.pageNo = 1;
      this.params.goodsTypeId = name;
      this.finished = false;
      this.list = [];
      this.getList();
    },
    async getList() {
      this.loading = true;
      let obj = this.$global.deepClone(this.params);
      obj.goodsTypeId++;
      const res = await this.$apis.extendServe.getExtendMyList(obj);
      if (res.resultCode === "200") {
        this.list.push(...res.data.list);
        this.finished = this.list.length >= +res.data.total;
      } else {
        this.finished = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.extend_list_box {
  height: 100%;
  .extend_list_tabs {
    height: 100%;
    &::v-deep .van-sticky--fixed {
      top: 44px !important;
    }
    &::v-deep .van-tabs__wrap {
      height: 45px;
      .van-tabs__nav {
        padding-bottom: 13px;
        .van-tab__text {
          font-size: 15px;
          color: #333;
        }
        .van-tab--active {
          .van-tab__text {
            color: #4a79f1;
          }
        }
        .van-tabs__line {
          width: 20px;
          background-color: #4a79f1;
        }
      }
    }
    &::v-deep .van-tabs__content {
      height: 100%;
      background-color: #f5f5f5;
      overflow: hidden;
      .van-list {
        padding: 12px 12px 0;
        background-color: #f5f5f5;
      }
    }
  }
  .extend_list_item {
    margin-top: 12px;
    padding: 13px 12px;
    background: #ffffff;
    border-radius: 8px;
    &:first-child {
      margin-top: 0;
    }
    .list_item_top {
      display: flex;
      margin-bottom: 13px;
      .list_item_cover {
        width: 80px;
        height: 80px;
        border-radius: 6px;
      }
      .list_item_title {
        flex: 1;
        margin-left: 10px;
        font-size: 15px;
        color: #333333;
        line-height: 23px;
      }
    }
    .list_item_bottom {
      display: flex;
      justify-content: space-around;
      padding: 11px 0 8px;
      background: #f5f5f5;
      border-radius: 6px;
      .list_item_text {
        margin-bottom: 7px;
        font-size: 12px;
        color: #333333;
        line-height: 17px;
      }
      .list_item_num {
        font-size: 16px;
        color: #ff3d3d;
        line-height: 23px;
        .list_item_symbol {
          font-size: 12px;
        }
      }
    }
  }
  .extend_list_no {
    margin-top: 116px;
    text-align: center;
    .none_img {
      width: 85px;
      height: 85px;
    }
    .no_text {
      margin: 15px 0 39px;
      font-size: 14px;
      color: #666666;
      line-height: 20px;
    }
    .no_btn {
      width: 210px;
      height: 44px;
      border-radius: 22px;
    }
  }
}
</style>